import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaCheck, FaCalculator, FaTruck, FaBox, FaEuroSign, FaCalendarAlt } from "react-icons/fa";
import { FaTruckRampBox } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import "./HeroSection.css";
import NavbarMenu from "./NavbarMenu";
import UmzugNavbarMenu from "./UmzugNavbarMenu";

export default function HeroSection({
  backgroundImage = "/default-hero.jpg",
  showTopbar = true,
  showNavbar = true,
  showUmzugNavbar = false,
  title = "Order Today, Delivered Today",
  titleHighlight = "Delivered Today",
  features = [],
  showQuoteForm = true,
  showCTAButton = true,
  ctaText = "Send Inquiry Now",
  ctaOnClick,
  customHeight,
  children,
  formType = "booking",
  showTransportBtn = false,
  showBookingBtn = false,
  ctaRoute,
  formComponent = null,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const titleParts = title.split(",");
  const mainTitle = titleParts[0]?.trim();
  const highlightTitle = titleHighlight || titleParts[1]?.trim();

  const getFeaturesArray = () => {
    if (Array.isArray(features)) {
      return features;
    } else if (typeof features === "object" && features !== null) {
      return Object.values(features);
    } else {
      return [];
    }
  };

  const featuresArray = getFeaturesArray();

  return (
    <>
      <header
        className="hero-section hero-section-centered"
        style={{
          minHeight: customHeight || "auto",
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        {showNavbar && <NavbarMenu />}

        {showUmzugNavbar && <UmzugNavbarMenu />}

        <div className="hero-content-wrapper">
          <Container fluid className="px-4 px-md-5">
            {children ? (
              children
            ) : (
              <>
                {/* Centered Text Content */}
                <div className="hero-text-centered" data-aos="fade-up">
                  <h1 className="text-uppercase hero-title-centered">
                    <span className="d-inline text-white">{t(mainTitle)},</span>{" "}
                    <span
                      className={
                        titleHighlight === "Delivered Today"
                          ? "text-warning typewriter"
                          : "text-warning"
                      }
                    >
                      {t(titleHighlight)}
                    </span>
                  </h1>

                  {featuresArray.length > 0 && (
                    <ul className="hero-list-centered">
                      {featuresArray.map((item, i) => (
                        <li
                          key={i}
                          data-aos="fade-up"
                          data-aos-delay={i * 100 + 200}
                        >
                          <FaCheck className="text-warning me-2" /> {t(item)}
                        </li>
                      ))}
                    </ul>
                  )}

                  {/* CTA Buttons */}
                  <div className="hero-buttons-centered" data-aos="fade-up" data-aos-delay="400">
                    {/* الزر الأول - JETZT DIREKT BUCHEN */}
                    {showCTAButton && (
                      <Button
                        size="lg"
                        className="hero-cta-btn"
                        onClick={() => {
                          if (ctaOnClick) {
                            ctaOnClick();
                          } else {
                            localStorage.removeItem("bookingData");
                            navigate(ctaRoute || "/bookings");
                          }
                        }}
                      >
                        <div className="d-flex align-items-center gap-3">
                          <div className="cta-icon-wrap" aria-hidden="true">
                            <FaCalendarAlt />
                          </div>
                          <div className="cta-text text-start">
                            <h5 className="mb-0 fw-bold">
                              {t("heroSection.btn1.title", "JETZT DIREKT BUCHEN")}
                            </h5>
                            <p className="mb-0 small opacity-75">
                              {t("heroSection.btn1.subtitle", "Fahrzeug sofort online buchen")}
                            </p>
                          </div>
                        </div>
                      </Button>
                    )}

                    {/* الزر الثاني - PREIS & ANGEBOT ANFRAGEN */}
                    <Button
                      size="lg"
                      className="hero-secondary-btn"
                      onClick={() => navigate("/transport")}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div className="cta-icon-wrap-secondary" aria-hidden="true">
                          <FaTruckRampBox />
                        </div>
                        <div className="cta-text text-start">
                          <h5 className="mb-0 fw-bold">
                            {t("heroSection.btn2.title", "PREIS & ANGEBOT ANFRAGEN")}
                          </h5>
                          <p className="mb-0 small opacity-75">
                            {t("heroSection.btn2.subtitle", "Für Umzüge, Möbel, Paletten & mehr")}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>

                  
                </div>
              </>
            )}
          </Container>
        </div>
      </header>

      {/* Form below Hero with negative margin-top */}
      {formComponent && (
        <div
          className="hero-form-container"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          {formComponent}
        </div>
      )}
    </>
  );
}
